import { Link, NavLink, Outlet } from 'react-router-dom';

/** Coach surface shell — distinct from the student app, reachable at /coach. */
export function CoachLayout() {
  return (
    <div className="coach">
      <header className="coach-top">
        <Link to="/coach" className="coach-brand">
          <img src="/logo-mark.svg" width={24} height={24} alt="" />
          <span>usaCow · Coach</span>
        </Link>
        <nav className="coach-nav">
          <NavLink to="/coach" end>
            Classes
          </NavLink>
          <Link to="/app">← Student app</Link>
        </nav>
      </header>
      <main className="coach-main">
        <Outlet />
      </main>
    </div>
  );
}
